import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, resolveComponent as _resolveComponent, createBlock as _createBlock, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = { class: "flex-fill" }
const _hoisted_3 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_4 = { class: "pl-2" }

import {
    getSelectedVirtualOperator,
    VirtualOperatorConfigInterface
} from "~/cabinet/vue/client/online/config/operators/virtual/Interface";
import {computed, ref} from "vue";
import VirtualOperatorConfigDialog
    from "~/cabinet/vue/client/online/config/operators/virtual/VirtualOperatorConfigDialog.vue";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "VirtualOperatorSelector"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    virtualOperators: {},
    siteId: {}
  }, {
    "modelValue": {
    type: String
},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

let props = __props;

let model = _useModel(__props, "modelValue");


let selectedOperator = computed(() => getSelectedVirtualOperator(props.virtualOperators, model.value));

let configDialogVisible = ref(false);

function onNewOperator(id: string) {
    model.value = id;
    configDialogVisible.value = false;
}


return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_select, {
        modelValue: _unref(model),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(model) ? (model).value = $event : model = $event)),
        class: "w-100",
        placeholder: "Выберите оператора",
        clearable: "",
        "no-data-text": "Не создано ни одного виртуального оператора"
      }, {
        label: _withCtx(() => [
          (_unref(selectedOperator))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_unref(selectedOperator).descr), 1)
              ], 64))
            : (_unref(model))
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, " Удалённый виртуальный оператор "))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createTextVNode(" Не выбран ")
                ], 64))
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.virtualOperators, (item) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: item.id,
              value: item.id,
              label: item.descr
            }, null, 8, ["value", "label"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_button, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_isRef(configDialogVisible) //@ts-ignore
 ? configDialogVisible.value = true : configDialogVisible = true))
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
          _createTextVNode("Настройка операторов", -1)
        ]))]),
        _: 1
      }),
      (_unref(configDialogVisible))
        ? (_openBlock(), _createBlock(VirtualOperatorConfigDialog, {
            key: 0,
            modelValue: _unref(configDialogVisible),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(configDialogVisible) ? (configDialogVisible).value = $event : configDialogVisible = $event)),
            "site-id": __props.siteId,
            "virtual-operators": __props.virtualOperators,
            onSelect: onNewOperator
          }, null, 8, ["modelValue", "site-id", "virtual-operators"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})